import { IconProps } from '@/utils/types';

export const IconSpinner: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" aria-hidden>
      <title>{title ? title : 'Loading'}</title>
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"></circle>
      <path
        className="ring-primary-500 opacity-75 ring-4"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  );
};

export const IconArrowUp: React.FC<IconProps> = ({
  className,
  strokeWidth,
  title,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      stroke="currentColor">
      <title>{title ? title : 'Arrow Up'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
      />
    </svg>
  );
};

export const IconArrowDown: React.FC<IconProps> = ({
  className,
  strokeWidth,
  title,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      stroke="currentColor">
      <title>{title ? title : 'Arrow Down'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
      />
    </svg>
  );
};

export const IconTurnDownLeft: React.FC<IconProps> = ({
  className,
  strokeWidth,
  title,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round">
      <title>{title ? title : 'Arrow Left'}</title>
      <path d="M8.75 10.501 5 14.251m0 0 3.75 3.75M5 14.251h10.5a4 4 0 0 0 4-4V5"></path>
    </svg>
  );
};

export const IconTurnDownRight: React.FC<IconProps> = ({
  className,
  strokeWidth,
  title,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round">
      <title>{title ? title : 'Arrow Right'}</title>
      <path d="M15.75 10.501L19.5 14.251M19.5 14.251L15.75 18.001M19.5 14.251H12.25H9C6.79086 14.251 5 12.4601 5 10.251V5" />
    </svg>
  );
};

export const IconMinus: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}
      stroke="currentColor"
      strokeWidth="2">
      <title>{title ? title : 'Minus'}</title>
      <path strokeLinecap="round" strokeLinejoin="round" d="M18 12H6" />
    </svg>
  );
};
export const IconAnnotation: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}
      stroke="currentColor"
      strokeWidth="2">
      <title>{title ? title : 'Annotation'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
      />
    </svg>
  );
};

export const IconSelector: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}
      stroke="currentColor"
      strokeWidth="2">
      <title>{title ? title : 'Selector'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 9l4-4 4 4m0 6l-4 4-4-4"
      />
    </svg>
  );
};

export const IconCheck: React.FC<IconProps> = props => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${props.className}`}>
      <title>{props.title ? props.title : 'Check'}</title>
      <path
        d="M5 13l4 4L19 7"
        stroke="currentColor"
        strokeWidth={props.strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconSearch: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}>
      <title>{title ? title : 'Search'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      />
    </svg>
  );
};

export const IconGrid: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}>
      <title>{title ? title : 'Grid'}</title>
      <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
    </svg>
  );
};

export const IconList: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}>
      <title>{title ? title : 'List'}</title>
      <path
        fillRule="evenodd"
        d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const IconLinkedIn: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <title>{title ? title : 'LinkedIn'}</title>
      <path d="M19.619 2H4.38095C3.06667 2 2 3.06667 2 4.38095V19.619C2 20.9333 3.06667 22 4.38095 22H19.619C20.9333 22 22 20.9333 22 19.619V4.38095C22 3.06667 20.9333 2 19.619 2ZM8.19048 9.61905V18.6667H5.33333V9.61905H8.19048ZM5.33333 6.98571C5.33333 6.31905 5.90476 5.80952 6.7619 5.80952C7.61905 5.80952 8.15714 6.31905 8.19048 6.98571C8.19048 7.65238 7.65714 8.19048 6.7619 8.19048C5.90476 8.19048 5.33333 7.65238 5.33333 6.98571ZM18.6667 18.6667H15.8095C15.8095 18.6667 15.8095 14.2571 15.8095 13.9048C15.8095 12.9524 15.3333 12 14.1429 11.981H14.1048C12.9524 11.981 12.4762 12.9619 12.4762 13.9048C12.4762 14.3381 12.4762 18.6667 12.4762 18.6667H9.61905V9.61905H12.4762V10.8381C12.4762 10.8381 13.3952 9.61905 15.2429 9.61905C17.1333 9.61905 18.6667 10.919 18.6667 13.5524V18.6667Z" />
    </svg>
  );
};

export const IconBriefcase: React.FC<IconProps> = ({
  className,
  title,
  strokeWidth,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      stroke="currentColor">
      <title>{title ? title : 'Briefcase'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
      />
    </svg>
  );
};

export const IconGlobe: React.FC<IconProps> = ({
  className,
  title,
  strokeWidth,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      stroke="currentColor">
      <title>{title ? title : 'Globe'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
      />
    </svg>
  );
};

export const IconEmail: React.FC<IconProps> = ({
  className,
  title,
  strokeWidth,
}) => {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      stroke="currentColor">
      <title>{title ? title : 'Email'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
      />
    </svg>
  );
};

export const IconPaperAirplane: React.FC<IconProps> = ({
  className,
  title,
  strokeWidth,
}) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      viewBox="0 0 24 24"
      aria-hidden>
      <title>{title ? title : 'Paper Plane'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
      />
    </svg>
  );
};

export const IconCaretLeft: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 9 16"
      stroke="currentColor"
      strokeWidth={1}>
      <title>{title ? title : 'Caret Left'}</title>
      <polyline
        fill="none"
        strokeMiterlimit="10"
        points="7.3,14.7 2.5,8 7.3,1.2"></polyline>
    </svg>
  );
};

export const IconCaretRight: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 9 16"
      stroke="currentColor"
      strokeWidth={1}>
      <title>{title ? title : 'Caret Right'}</title>
      <polyline
        fill="none"
        strokeMiterlimit="10"
        points="1.6,1.2 6.5,7.9 1.6,14.7"></polyline>
    </svg>
  );
};

export const IconChevronRight: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}>
      <title>{title ? title : 'Right'}</title>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
  );
};

export const IconChevronDown: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}>
      <title>{title ? title : 'Down'}</title>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
};

export const IconChevronUp: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}>
      <title>{title ? title : 'Down'}</title>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
    </svg>
  );
};

export const IconClose: React.FC<IconProps> = ({
  className,
  title,
  strokeWidth,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}>
      <title>{title ? title : 'Close'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
};

export const IconLocation: React.FC<IconProps> = ({
  className,
  title,
  strokeWidth,
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      stroke="currentColor">
      <title>{title ? title : 'Location'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
      />
    </svg>
  );
};

export const IconSort: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none">
      <title>{title ? title : 'Sort'}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.4917 1.69645C4.4917 1.45761 4.39682 1.22855 4.22793 1.05966C4.05905 0.890778 3.82999 0.795898 3.59115 0.795898C3.35231 0.795898 3.12325 0.890778 2.95436 1.05966C2.78547 1.22855 2.69059 1.45761 2.69059 1.69645V12.1303L1.52618 10.9658C1.35633 10.8018 1.12885 10.711 0.892728 10.7131C0.656606 10.7151 0.430736 10.8098 0.263766 10.9768C0.0967961 11.1438 0.00208588 11.3697 3.40433e-05 11.6058C-0.00201779 11.8419 0.0887529 12.0694 0.252796 12.2392L2.95446 14.9409C3.12333 15.1097 3.35235 15.2046 3.59115 15.2046C3.82994 15.2046 4.05896 15.1097 4.22784 14.9409L6.9295 12.2392C7.09354 12.0694 7.18431 11.8419 7.18226 11.6058C7.18021 11.3697 7.0855 11.1438 6.91853 10.9768C6.75156 10.8098 6.52569 10.7151 6.28957 10.7131C6.05344 10.711 5.82596 10.8018 5.65612 10.9658L4.4917 12.1303V1.69645ZM9.89502 2.59701C9.65618 2.59701 9.42712 2.69188 9.25823 2.86077C9.08935 3.02966 8.99447 3.25872 8.99447 3.49756C8.99447 3.7364 9.08935 3.96546 9.25823 4.13435C9.42712 4.30323 9.65618 4.39811 9.89502 4.39811H17.0994C17.3383 4.39811 17.5673 4.30323 17.7362 4.13435C17.9051 3.96546 18 3.7364 18 3.49756C18 3.25872 17.9051 3.02966 17.7362 2.86077C17.5673 2.69188 17.3383 2.59701 17.0994 2.59701H9.89502ZM9.89502 7.09977C9.65618 7.09977 9.42712 7.19465 9.25823 7.36354C9.08935 7.53242 8.99447 7.76148 8.99447 8.00033C8.99447 8.23917 9.08935 8.46823 9.25823 8.63711C9.42712 8.806 9.65618 8.90088 9.89502 8.90088H13.4972C13.7361 8.90088 13.9651 8.806 14.134 8.63711C14.3029 8.46823 14.3978 8.23917 14.3978 8.00033C14.3978 7.76148 14.3029 7.53242 14.134 7.36354C13.9651 7.19465 13.7361 7.09977 13.4972 7.09977H9.89502ZM9.89502 11.6025C9.65618 11.6025 9.42712 11.6974 9.25823 11.8663C9.08935 12.0352 8.99447 12.2643 8.99447 12.5031C8.99447 12.7419 9.08935 12.971 9.25823 13.1399C9.42712 13.3088 9.65618 13.4036 9.89502 13.4036H10.7956C11.0344 13.4036 11.2635 13.3088 11.4324 13.1399C11.6012 12.971 11.6961 12.7419 11.6961 12.5031C11.6961 12.2643 11.6012 12.0352 11.4324 11.8663C11.2635 11.6974 11.0344 11.6025 10.7956 11.6025H9.89502Z"
        fill="#0E0067"
      />
    </svg>
  );
};

export const IconSortDown: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor">
      <title>{title ? title : 'Sort'}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.4917 5.90055C7.4917 5.66171 7.39682 5.43265 7.22793 5.26377C7.05905 5.09488 6.82999 5 6.59115 5C6.35231 5 6.12325 5.09488 5.95436 5.26377C5.78547 5.43265 5.69059 5.66171 5.69059 5.90055V16.3344L4.52618 15.1699C4.35633 15.0059 4.12885 14.9151 3.89273 14.9172C3.65661 14.9192 3.43074 15.0139 3.26377 15.1809C3.0968 15.3479 3.00209 15.5738 3.00003 15.8099C2.99798 16.046 3.08875 16.2735 3.2528 16.4433L5.95446 19.145C6.12333 19.3138 6.35235 19.4087 6.59115 19.4087C6.82994 19.4087 7.05896 19.3138 7.22784 19.145L9.9295 16.4433C10.0935 16.2735 10.1843 16.046 10.1823 15.8099C10.1802 15.5738 10.0855 15.3479 9.91853 15.1809C9.75156 15.0139 9.52569 14.9192 9.28957 14.9172C9.05344 14.9151 8.82596 15.0059 8.65612 15.1699L7.4917 16.3344V5.90055ZM12.895 6.80111C12.6562 6.80111 12.4271 6.89599 12.2582 7.06487C12.0893 7.23376 11.9945 7.46282 11.9945 7.70166C11.9945 7.9405 12.0893 8.16956 12.2582 8.33845C12.4271 8.50733 12.6562 8.60221 12.895 8.60221H20.0994C20.3383 8.60221 20.5673 8.50733 20.7362 8.33845C20.9051 8.16956 21 7.9405 21 7.70166C21 7.46282 20.9051 7.23376 20.7362 7.06487C20.5673 6.89599 20.3383 6.80111 20.0994 6.80111H12.895ZM12.895 11.3039C12.6562 11.3039 12.4271 11.3988 12.2582 11.5676C12.0893 11.7365 11.9945 11.9656 11.9945 12.2044C11.9945 12.4433 12.0893 12.6723 12.2582 12.8412C12.4271 13.0101 12.6562 13.105 12.895 13.105H16.4972C16.7361 13.105 16.9651 13.0101 17.134 12.8412C17.3029 12.6723 17.3978 12.4433 17.3978 12.2044C17.3978 11.9656 17.3029 11.7365 17.134 11.5676C16.9651 11.3988 16.7361 11.3039 16.4972 11.3039H12.895ZM12.895 15.8066C12.6562 15.8066 12.4271 15.9015 12.2582 16.0704C12.0893 16.2393 11.9945 16.4684 11.9945 16.7072C11.9945 16.946 12.0893 17.1751 12.2582 17.344C12.4271 17.5129 12.6562 17.6077 12.895 17.6077H13.7956C14.0344 17.6077 14.2635 17.5129 14.4324 17.344C14.6012 17.1751 14.6961 16.946 14.6961 16.7072C14.6961 16.4684 14.6012 16.2393 14.4324 16.0704C14.2635 15.9015 14.0344 15.8066 13.7956 15.8066H12.895Z"
      />
    </svg>
  );
};

export const IconSortUp: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor">
      <title>{title ? title : 'Sort'}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8951 6.80108C12.6562 6.80108 12.4272 6.89596 12.2583 7.06484C12.0894 7.23373 11.9945 7.46279 11.9945 7.70163C11.9945 7.94047 12.0894 8.16953 12.2583 8.33842C12.4272 8.5073 12.6562 8.60218 12.8951 8.60218H20.0995C20.3383 8.60218 20.5674 8.5073 20.7363 8.33842C20.9052 8.16953 21 7.94047 21 7.70163C21 7.46279 20.9052 7.23373 20.7363 7.06484C20.5674 6.89596 20.3383 6.80108 20.0995 6.80108H12.8951ZM12.8951 11.3038C12.6562 11.3038 12.4272 11.3987 12.2583 11.5676C12.0894 11.7365 11.9945 11.9656 11.9945 12.2044C11.9945 12.4432 12.0894 12.6723 12.2583 12.8412C12.4272 13.0101 12.6562 13.1049 12.8951 13.1049H16.4973C16.7361 13.1049 16.9652 13.0101 17.1341 12.8412C17.303 12.6723 17.3978 12.4432 17.3978 12.2044C17.3978 11.9656 17.303 11.7365 17.1341 11.5676C16.9652 11.3987 16.7361 11.3038 16.4973 11.3038H12.8951ZM12.8951 15.8066C12.6562 15.8066 12.4272 15.9015 12.2583 16.0704C12.0894 16.2393 11.9945 16.4683 11.9945 16.7072C11.9945 16.946 12.0894 17.1751 12.2583 17.344C12.4272 17.5128 12.6562 17.6077 12.8951 17.6077H13.7956C14.0345 17.6077 14.2635 17.5128 14.4324 17.344C14.6013 17.1751 14.6962 16.946 14.6962 16.7072C14.6962 16.4683 14.6013 16.2393 14.4324 16.0704C14.2635 15.9015 14.0345 15.8066 13.7956 15.8066H12.8951Z"
      />
      <path d="M5.95436 19.1449C5.78547 18.976 5.69059 18.7469 5.69059 18.5081L5.69059 8.0743L4.52618 9.23871C4.35633 9.40275 4.12885 9.49353 3.89273 9.49147C3.65661 9.48942 3.43074 9.39471 3.26377 9.22774C3.0968 9.06077 3.00209 8.8349 3.00003 8.59878C2.99798 8.36266 3.08875 8.13518 3.2528 7.96533L5.95446 5.26367C6.12333 5.09484 6.35235 5 6.59115 5C6.82994 5 7.05896 5.09484 7.22784 5.26367L9.9295 7.96533C10.0935 8.13518 10.1843 8.36266 10.1823 8.59878C10.1802 8.8349 10.0855 9.06077 9.91853 9.22774C9.75156 9.39471 9.52569 9.48942 9.28957 9.49147C9.05344 9.49353 8.82596 9.40275 8.65612 9.23871L7.4917 8.0743L7.4917 18.5081C7.4917 18.7469 7.39682 18.976 7.22793 19.1449C7.05905 19.3138 6.82999 19.4087 6.59115 19.4087C6.3523 19.4087 6.12325 19.3138 5.95436 19.1449Z" />
    </svg>
  );
};

export const IconCash: React.FC<IconProps> = ({ className, title }) => {
  return (
    // <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"  className="size-6">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      // fill="currentColor"
      fill="none"
      stroke="currentColor"
      strokeWidth="2">
      <title>{title ? title : 'Cash'}</title>

      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
      />
    </svg>
  );
};

export const IconTwitter: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden>
      <title>{title ? title : 'Twitter'}</title>
      <path d="M7.548 22.501c9.056 0 14.01-7.503 14.01-14.01 0-.213 0-.425-.015-.636A10.02 10.02 0 0024 5.305a9.828 9.828 0 01-2.828.776 4.94 4.94 0 002.165-2.724 9.867 9.867 0 01-3.127 1.195 4.929 4.929 0 00-8.391 4.491A13.98 13.98 0 011.67 3.9a4.928 4.928 0 001.525 6.573A4.887 4.887 0 01.96 9.855v.063a4.926 4.926 0 003.95 4.827 4.917 4.917 0 01-2.223.084 4.93 4.93 0 004.6 3.42A9.88 9.88 0 010 20.289a13.941 13.941 0 007.548 2.209" />
    </svg>
  );
};

export const IconX: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden>
      <title>{title ? title : 'X'}</title>
      <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75403L10.7663 14.0113L15.5685 21H20.8131L13.6823 10.6218ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.0956Z" />
    </svg>
  );
};

export const IconDribbble: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden>
      <title>{title ? title : 'Dribbble'}</title>

      <path
        fillRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c5.51 0 10-4.48 10-10S17.51 2 12 2zm6.605 4.61a8.502 8.502 0 011.93 5.314c-.281-.054-3.101-.629-5.943-.271-.065-.141-.12-.293-.184-.445a25.416 25.416 0 00-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362zM12 3.475c2.17 0 4.154.813 5.662 2.148-.152.216-1.443 1.941-4.48 3.08-1.399-2.57-2.95-4.675-3.189-5A8.687 8.687 0 0112 3.475zm-3.633.803a53.896 53.896 0 013.167 4.935c-3.992 1.063-7.517 1.04-7.896 1.04a8.581 8.581 0 014.729-5.975zM3.453 12.01v-.26c.37.01 4.512.065 8.775-1.215.25.477.477.965.694 1.453-.109.033-.228.065-.336.098-4.404 1.42-6.747 5.303-6.942 5.629a8.522 8.522 0 01-2.19-5.705zM12 20.547a8.482 8.482 0 01-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337.022-.01.033-.01.054-.022a35.318 35.318 0 011.823 6.475 8.4 8.4 0 01-3.341.684zm4.761-1.465c-.086-.52-.542-3.015-1.659-6.084 2.679-.423 5.022.271 5.314.369a8.468 8.468 0 01-3.655 5.715z"
        clipRule="evenodd"></path>
    </svg>
  );
};

export const IconInstagram: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden>
      <title>{title ? title : 'Instagram'}</title>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069ZM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0Zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324ZM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881Z" />
    </svg>
  );
};

export const IconGithub: React.FC<IconProps> = ({ className, title }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden>
      <title>{title ? title : 'Github'}</title>
      <path
        fillRule="evenodd"
        d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
        clipRule="evenodd"></path>
    </svg>
  );
};
